module.exports = __webpack_public_path__ + "static/35-9893f4c449e9860064c605f51572ece1.png";